import axios from 'axios';

export interface NewsType {
  category: string;
  content: string;
  id: string;
  important_flg: boolean;
  publishedAt: string;
  title: string;
  updatedAt: string;
}

// お知らせ(一般情報)一覧取得
export const getNewsList = async (
  currentPage: number
): Promise<{
  contents: NewsType[];
  totalCount: number;
}> => {
  const url = `https://${process.env.REACT_APP_MICRO_CMS_DOMAIN}.microcms.io/api/v1/${process.env.REACT_APP_MICRO_CMS_NEWS_ENDPOINT}`;
  const response = await axios.get(url, {
    headers: {
      'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY,
      'x-xsrf-token': undefined
    },
    params: {
      offset: (currentPage - 1) * 10,
      orders: '-publishedAt'
    }
  });
  const data = response.data.contents.map(
    (item: {
      category: { name: string };
      content: string;
      id: string;
      important_flg: boolean;
      publishedAt: string;
      title: string;
    }) => {
      return {
        ...item,
        category: item.category.name
      };
    }
  );
  return { contents: data, totalCount: response.data.totalCount };
};

// お知らせ(一般情報)詳細取得
export const getNews = async (id: string): Promise<NewsType> => {
  const url = `https://${process.env.REACT_APP_MICRO_CMS_DOMAIN}.microcms.io/api/v1/${process.env.REACT_APP_MICRO_CMS_NEWS_ENDPOINT}/${id}`;
  const response = await axios.get(url, {
    headers: {
      'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY,
      'x-xsrf-token': undefined
    }
  });
  const data = {
    ...response.data,
    category: response.data.category.name
  };
  return data;
};
